import { PatientDobChangeWarningMixin } from '../Mixins/PatientDobChangeWarningMixin.js';
export class PatientDemographics extends PatientDobChangeWarningMixin(HTMLElement)
{
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.init();
    }

    init() {
    }

}

customElements.define('patient-demographics', PatientDemographics);